export const titles = ['Name', 'Email', 'Company', 'Role'];
